import { Component } from '@angular/core';
import { EnumTransformService } from '../../services/enum-transform.service';

@Component({
  selector: 'pt-enum-renderer',
  template: `<span>{{params.value | async}}</span>`
})
export class EnumRendererComponent {

  params: any;

  constructor(private enumTransformService: EnumTransformService) {
  }

  agInit(params: any): void {
    this.params = params;
    this.params.value = this.enumTransformService.toAdverbWithoutLabels(this.params.value);
  }

}
